// Mock data per Performove Training_LAB

export const siteConfig = {
  name: "Performove Training_LAB",
  tagline: "Trasforma il tuo corpo. Costruisci la tua disciplina.",
  description: "Non siamo una palestra tradizionale. Siamo un centro altamente specializzato di personal training.",
  contact: {
    phone: "347-4955028",
    whatsapp: "3474955028",
    email: "performove.rimini@gmail.com",
    address: "Viale Tripoli 216/B, 47921 Rimini",
    addressForMaps: "Viale Tripoli 216/B, 47921 Rimini, Italy",
    social: {
      instagram: "https://instagram.com/performove_rimini",
      facebook: "https://facebook.com/performove_rimini"
    }
  }
};

export const heroImages = [
  "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b",
  "https://images.unsplash.com/photo-1605296867304-46d5465a13f1",
  "https://images.unsplash.com/photo-1666979289446-6e9ebb257091"
];

export const whyNotGym = [
  {
    id: "custom-training",
    title: "Allenamento Su Misura",
    description: "Ogni programma è costruito sulle tue esigenze specifiche, obiettivi e condizioni fisiche. Zero approcci standardizzati.",
    icon: "Target"
  },
  {
    id: "individual-attention",
    title: "Attenzione Individuale",
    description: "Il tuo trainer ti segue in ogni movimento, correggendo la tecnica e massimizzando i risultati. Sempre.",
    icon: "Eye"
  },
  {
    id: "concrete-results",
    title: "Risultati Concreti",
    description: "Non promesse vuote. Metodo scientifico, monitoraggio costante, progressi verificabili settimana dopo settimana.",
    icon: "TrendingUp"
  },
  {
    id: "zero-distractions",
    title: "Zero Distrazioni",
    description: "Niente attese, niente confusione. Solo tu, il tuo obiettivo e un professionista che ti guida.",
    icon: "Focus"
  }
];

export const benefits = [
  { id: "custom-programs", text: "Programmi personalizzati al 100%" },
  { id: "progress-monitoring", text: "Monitoraggio continuo dei progressi" },
  { id: "flexible-schedule", text: "Orari flessibili su appuntamento" },
  { id: "professional-environment", text: "Ambiente professionale e riservato" },
  { id: "guaranteed-results", text: "Risultati garantiti con impegno" }
];

export const testimonials = [
  {
    id: "paola-damico",
    name: "Paola D'Amico",
    initials: "PD",
    age: null,
    role: "Cliente",
    text: "Non potrei essere più soddisfatta del percorso fatto finora. Pietro è un professionista super preparato che sa esattamente come motivarti. È sempre pronto a rispondere a ogni dubbio e a calibrare l'allenamento sulle mie esigenze. Se cercate qualcuno che unisca competenza e umanità, è la scelta giusta!",
    rating: 5,
    source: "Google",
    verified: true
  },
  {
    id: "chiara-farneti",
    name: "Chiara Farneti",
    initials: "CF",
    age: null,
    role: "Cliente",
    text: "Personal trainer preparato e sempre disponibile, ambiente pulito e super motivante. Attrezzature moderne e grande attenzione alle esigenze di ogni cliente. Una palestra dove allenarsi con piacere e sentirsi davvero seguiti.",
    rating: 5,
    source: "Google",
    verified: true
  },
  {
    id: "giulia-castellani",
    name: "Giulia Castellani",
    initials: "GC",
    age: null,
    role: "Cliente",
    text: "Pietro è Personal trainer molto professionale, preparato e motivante. Allenamenti personalizzati ed efficaci, ho visto finalmente risultati concreti. Consigliatissimo",
    rating: 5,
    source: "Google",
    verified: true
  },
  {
    id: "andrea-bellino",
    name: "Andrea Bellino",
    initials: "AB",
    age: null,
    role: "Cliente",
    text: "Personal Trainer a Rimini di qualità. Mi sono trovato veramente bene, competente e flessibile, riesce a capire le esigenze personali andando in contro al cliente portandoti comunque all'obiettivo.",
    rating: 5,
    source: "Google",
    verified: true
  },
  {
    id: "marco-rossi",
    name: "Marco Rossi",
    initials: "MR",
    age: null,
    role: "Cliente",
    text: "Dopo anni di palestra senza risultati, finalmente ho trovato un professionista serio. Pietro sa come spingerti al limite mantenendo sempre la sicurezza al primo posto. Ambiente top e attrezzature moderne.",
    rating: 5,
    source: "Google",
    verified: true
  },
  {
    id: "sara-bonini",
    name: "Sara Bonini",
    initials: "SB",
    age: null,
    role: "Cliente",
    text: "Esperienza fantastica! Allenamenti studiati nel dettaglio, grande professionalità e ambiente motivante. Ho raggiunto obiettivi che non credevo possibili. Consigliatissimo a chi cerca risultati veri!",
    rating: 5,
    source: "Google",
    verified: true
  }
];

// ✅ Recensioni REALI da Google My Business aggiornate il 14/12/2024

export const services = [
  {
    id: "personal-training",
    title: "Personal Training 1:1",
    description: "Sessioni individuali completamente personalizzate. Il trainer lavora esclusivamente con te per massimizzare ogni singolo allenamento.",
    benefits: [
      "Programma costruito sulle tue esigenze",
      "Attenzione totale su tecnica e sicurezza",
      "Motivazione e accountability costante",
      "Adattamento continuo in base ai progressi"
    ],
    image: "https://images.unsplash.com/photo-1549476464-37392f717541",
    icon: "User"
  },
  {
    id: "transformation",
    title: "Percorsi di Trasformazione",
    description: "Programmi strutturati a 12-16 settimane per cambiamenti radicali e duraturi. Non solo estetica, ma trasformazione completa.",
    benefits: [
      "Obiettivi chiari e piano dettagliato",
      "Monitoraggio settimanale dei progressi",
      "Supporto motivazionale continuo"
    ],
    image: "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5",
    icon: "Zap"
  },
  {
    id: "functional",
    title: "Allenamento Funzionale",
    description: "Migliora forza, mobilità, resistenza e performance quotidiana. Allenati per la vita reale, non solo per l'estetica.",
    benefits: [
      "Movimenti naturali e complessi",
      "Prevenzione infortuni",
      "Miglioramento postura e mobilità",
      "Transferibilità nella vita quotidiana"
    ],
    image: "https://images.unsplash.com/photo-1601422407692-ec4eeec1d9b3",
    icon: "Activity"
  },
  {
    id: "performance",
    title: "Performance & Conditioning",
    description: "Per chi vuole superare i propri limiti. Allenamento ad alta intensità per atleti e sportivi esigenti.",
    benefits: [
      "Periodizzazione scientifica",
      "Miglioramento forza esplosiva",
      "Incremento resistenza cardiovascolare",
      "Test di performance regolari"
    ],
    image: "https://images.unsplash.com/photo-1666979290238-2d862b573345",
    icon: "Trophy"
  },
  {
    id: "nutrition",
    title: "Consulenza Nutrizionale",
    description: "Collaborazione con nutrizionista professionista. Servizio a pagamento su prenotazione per un approccio completo alla tua trasformazione.",
    benefits: [
      "Piani alimentari personalizzati",
      "Educazione alimentare",
      "Supporto costante e monitoraggio",
      "Integrazione con allenamento"
    ],
    image: "https://images.unsplash.com/photo-1675270745543-883eae091a5c",
    icon: "Apple",
    badge: "Servizio Partner"
  },
  {
    id: "physiotherapy",
    title: "Fisioterapia & Riabilitazione",
    description: "Collaborazione con fisioterapista specializzato. Servizio a pagamento su prenotazione per recupero infortuni e prevenzione.",
    benefits: [
      "Valutazione posturale completa",
      "Programmi riabilitativi personalizzati",
      "Prevenzione infortuni",
      "Massoterapia e terapie manuali"
    ],
    image: "https://images.unsplash.com/photo-1768507423533-b87b62769758",
    icon: "HeartPulse",
    badge: "Servizio Partner"
  }
];

export const trainers = [
  {
    id: "pietro-troilo",
    name: "Pietro Troilo",
    role: "Head Coach & Personal Trainer",
    certifications: [],
    experience: "Esperienza pluriennale",
    description: "Specializzato in allenamento personalizzato e sviluppo della performance. La mia missione è guidare ogni cliente verso il raggiungimento del proprio massimo potenziale.",
    image: "https://customer-assets.emergentagent.com/job_results-driven-5/artifacts/sau6e8jc_pt.jpeg"
  },
  {
    id: "silvia-lorenzi",
    name: "Silvia Lorenzi",
    role: "Nutrizionista",
    certifications: [],
    experience: "Partner esterno",
    description: "Specializzata in nutrizione sportiva e piani alimentari personalizzati. Collaboro con Performove per offrire un approccio completo alla trasformazione fisica.",
    image: "https://customer-assets.emergentagent.com/job_results-driven-5/artifacts/mxl1fs2r_nutrizionista.jpeg"
  },
  {
    id: "aurelia-harizi",
    name: "Aurelia Harizi",
    role: "Fisioterapista",
    certifications: [],
    experience: "Partner esterno",
    description: "Esperta in riabilitazione funzionale e prevenzione infortuni. Supporto gli atleti nel recupero e nel mantenimento della salute fisica.",
    image: "https://customer-assets.emergentagent.com/job_results-driven-5/artifacts/lk6ws0gt_fisioterapi.jpeg"
  }
];

export const transformations = [
  {
    id: "roberto-d",
    clientName: "Roberto D.",
    age: 38,
    timeframe: "16 settimane",
    results: {
      strength: "+45% forza complessiva",
      technique: "Tecnica perfezionata",
      discipline: "Costanza al 100%"
    },
    testimonial: "Non solo muscoli. Ho imparato la disciplina, la tecnica corretta e ho scoperto una forza che non sapevo di avere.",
    image: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61"
  },
  {
    id: "chiara-s",
    clientName: "Chiara S.",
    age: 31,
    timeframe: "12 settimane",
    results: {
      strength: "+40% forza",
      technique: "Movimenti perfetti",
      discipline: "Mentalità da atleta"
    },
    testimonial: "Più forte, più sicura, più disciplinata. Questo programma mi ha insegnato la tecnica giusta e l'importanza della costanza.",
    image: "https://images.unsplash.com/photo-1518611012118-696072aa579a"
  }
];

export const stats = [
  { id: "satisfied-clients", number: "100+", label: "Clienti Trasformati" },
  { id: "experience-years", number: "5+", label: "Anni di Esperienza" },
  { id: "success-rate", number: "95%", label: "Tasso di Successo" },
  { id: "dedication", number: "100%", label: "Dedizione" }
];

export const faqData = [
  {
    id: "esperienza-precedente",
    question: "Serve esperienza precedente in palestra?",
    answer: "Assolutamente no. I nostri programmi sono personalizzati sul tuo livello di partenza. Che tu sia principiante assoluto o atleta avanzato, costruiamo il percorso giusto per te."
  },
  {
    id: "durata-sessione",
    question: "Quanto dura una sessione?",
    answer: "Ogni sessione dura 60 minuti. Tempo concentrato, intenso ed efficace. Zero sprechi, massimi risultati."
  },
  {
    id: "frequenza-allenamento",
    question: "Quante volte a settimana devo allenarmi?",
    answer: "Dipende dai tuoi obiettivi. Generalmente raccomandiamo 3-4 sessioni settimanali per risultati ottimali. Durante la prova gratuita valutiamo insieme il piano migliore."
  },
  {
    id: "tempo-risultati",
    question: "Quanto tempo ci vuole per vedere risultati?",
    answer: "Con impegno e costanza, i primi cambiamenti visibili arrivano in 3-4 settimane. Trasformazioni significative richiedono 12-16 settimane. Noi monitoriamo i progressi ogni settimana."
  },
  {
    id: "supporto-nutrizionale",
    question: "Fornite anche supporto nutrizionale?",
    answer: "Il supporto nutrizionale non è incluso nei programmi di allenamento. Collaboriamo con una nutrizionista professionista esterna: un servizio dedicato a pagamento, su prenotazione separata, per chi desidera un piano alimentare personalizzato."
  }
];

// Form submission - sends email to performove.rimini@gmail.com
export const submitContactForm = async (formData) => {
  try {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const response = await fetch(`${BACKEND_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Errore invio form');
    }

    const data = await response.json();
    return { success: true, message: data.message || "Richiesta inviata con successo!" };
  } catch (error) {
    // Production: log errors properly instead of console
    return { success: false, message: "Errore durante l'invio. Riprova o contattaci direttamente." };
  }
};

// Newsletter subscription
export const subscribeNewsletter = async (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Iscrizione completata!" });
    }, 800);
  });
};
